/** @format */

import Axios from 'axios';
import { frontend_url } from '@/config';

// La generacion del PDF corre en una Cloud Function (fuera del box), la misma
// que usaba el boton de descarga individual del gestor viejo.
const GENERADOR_PDF = 'https://southamerica-east1-plhain.cloudfunctions.net/descargarPDF';

export const urlAbsolutaOT = enlaceRelativo => {
	// la Cloud Function abre la pagina por su cuenta: nunca puede ser localhost
	const base = String(frontend_url || window.location.origin).replace(/\/(#\/?)?$/, '');
	return `${base}/${String(enlaceRelativo).replace(/^\/+/, '')}`;
};

export const nombreArchivoOT = orden =>
	`OT ${orden.folio} - ${orden.lugar || 'sin lugar'}`.replace(/[\\/:*?"<>|]/g, '-');

/**
 * Descarga el PDF de una OT. El gestor viejo no tenia try/catch ni timeout:
 * si la funcion fallaba, el spinner de la fila giraba para siempre.
 */
export const descargarPdfDeOT = async (orden, opciones = {}) => {
	const { timeout = 90000, signal } = opciones;
	const respuesta = await Axios(GENERADOR_PDF, {
		method: 'post',
		responseType: 'arraybuffer',
		data: { url: urlAbsolutaOT(orden.urlVer) },
		timeout,
		signal,
	});
	guardarBlob(
		new Blob([respuesta.data], { type: 'application/pdf' }),
		`${nombreArchivoOT(orden)}.pdf`
	);
	return true;
};

export const guardarBlob = (blob, nombre) => {
	const url = window.URL.createObjectURL(blob);
	const enlace = document.createElement('a');
	enlace.href = url;
	enlace.download = nombre;
	document.body.appendChild(enlace);
	enlace.click();
	enlace.remove();
	// sin revoke, cada descarga deja el blob retenido en memoria
	window.setTimeout(() => window.URL.revokeObjectURL(url), 2000);
};
